import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-email',
  templateUrl: './email.component.html',
})
export class EmailComponent {
  @Input () parentForm: FormGroup;

  get f() {
    return this.parentForm.controls;
  }
}
